import logohorizontal from "../assets/logohorizontal.png";

export const Header = () => {
  return (
    <div style={{
      height: 48,
      background: "#ffffff",
      borderBottom: "1px solid #f1f5f9",
      display: "flex",
      alignItems: "center",
      paddingLeft: 20,
      paddingRight: 20,
      flexShrink: 0,
      // Sem position fixed/sticky — fica no fluxo normal do layout
      // Se o seu Layout usa <Toolbar /> como espaçador abaixo do AppBar,
      // pode remover ele agora que o Header não é mais um AppBar
    }}>
      <img
        src={logohorizontal}
        alt="logo"
        style={{ height: 26, objectFit: "contain" }}
      />
    </div>
  );
};

export default Header;